import View from 'view/base';
import Router from 'root/router';
import View_Onboarding_Profile from 'view/onboarding/profile';
import View_Onboarding_Workspace from 'view/onboarding/workspace';
import View_Onboarding_Usecase from 'view/onboarding/use_case';

export default View.extend({
    className: 'onboarding-container onboarding-container-simple',

    step: 'profile',

    steps: ['profile', 'workspace', 'use_case'],

    views: {
        step: {}
    },

    goToStep: function(target) {
        this.step = target;

        if (this.views.step && this.views.step.remove) {
            this.views.step.remove();
        }

        this.createStepView();
    },

    createStepView: function() {
        switch (this.step) {
            case 'profile':
                this.views.step = new View_Onboarding_Profile();
                break;
            case 'workspace':
                this.views.step = new View_Onboarding_Workspace();
                break;
            case 'use_case':
                this.views.step = new View_Onboarding_Usecase();
                break;
        }

        this.views.step.on('complete', () => {
            Router.navigate('/project/?onboarding=1', {trigger: true});
            return;
        });

        this.views.step.on('back', () => {
            switch (this.step) {
                case 'use_case':
                    this.goToStep('workspace');
                    break;
                case 'workspace':
                    this.goToStep('profile');
                    break;
            }
        });

        this.views.step.render().$el.appendTo(this.$el);

        // hack: wait for the parent view to be rendered first
        setTimeout(() => {
            this.$el.find('form input:first').focus();
        });
    },

    render: function() {
        this.createStepView();

        return this;
    }
});